import { useState } from "react";

const Register = ({ onRegister }) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    confirm_password: "",
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    try {
      await onRegister({ ...form, role: "Trainee" });
      setMessage("Registration successful. Login to continue.");
      setForm({ name: "", email: "", phone: "", password: "", confirm_password: "" });
    } catch (err) {
      setError(err.message || "Registration failed");
    }
  };

  return (
    <section className="auth-page">
      <div className="auth-illustration">
        <p className="eyebrow">Create account</p>
        <h2>Join the next cohort</h2>
        <p className="muted">Share a few details so your trainer can welcome you.</p>
        <ul className="bullet-list">
          <li>Access attendance, tasks, and announcements in one place.</li>
          <li>Save placement preferences and apply to curated roles.</li>
          <li>Stay synced with trainers through milestones and feedback.</li>
        </ul>
      </div>

      <div className="auth-card">
        <h1>Register as Trainee</h1>
        <form onSubmit={handleSubmit}>
          <label>
            Full Name
            <input name="name" value={form.name} onChange={handleChange} required />
          </label>
          <label>
            Email
            <input name="email" type="email" value={form.email} onChange={handleChange} required />
          </label>
          <label>
            Phone
            <input name="phone" value={form.phone} onChange={handleChange} />
          </label>
          <label>
            Password
            <input
              name="password"
              type="password"
              value={form.password}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Confirm Password
            <input
              name="confirm_password"
              type="password"
              value={form.confirm_password}
              onChange={handleChange}
              required
            />
          </label>
          <p className="muted small">Role: Trainee</p>
          <button type="submit" className="primary">
            Register
          </button>
          {error && <p className="error-callout">{error}</p>}
          {message && <p className="success-callout">{message}</p>}
        </form>
      </div>
    </section>
  );
};

export default Register;
